import {
  SortOrderEnum,
  UserSortColumnEnum,
} from '@ulysses-inc/harami_api_client'
import type { GetUsersFilter } from 'src/state/ducks/users/types'

export type UsersSortOrder = {
  sortColumn: UserSortColumnEnum
  sortOrder: SortOrderEnum
}

/**
 * 初回表示・並び替えクリア時の既定値。
 *
 * API は sortColumn 未指定時に ORDER BY を付けない（並び順を保証しない）ため、
 * 既定の並び順は呼び出し側であるここが明示的に指定する。
 * 値は仕様として定めた既定 (追加日時の新しい順) に合わせている。
 * Feature Flag が OFF の間は ORDER BY 自体が付かず並び順は不定のため、
 * この既定値は「OFF 時の並びの再現」ではない点に注意。
 */
export const DEFAULT_USERS_SORT_ORDER: UsersSortOrder = {
  sortColumn: UserSortColumnEnum.CreatedAt,
  sortOrder: SortOrderEnum.Desc,
}

/**
 * 絞り込み条件に並び替え条件を合成する。
 *
 * UsersFilterDropDown は並び替えの存在を知らずに setUserFilter を呼ぶため、
 * 絞り込みの再計算で並び替えが失われないよう、API へ渡す直前にここで合成する。
 * sortOrder が undefined (Feature Flag OFF / 判定中) のときは sortColumn を送らず、
 * API 側にも ORDER BY が付かない従来どおりの挙動になる。
 */
export const mergeSortIntoFilter = (
  filter: GetUsersFilter | undefined,
  sortOrder: UsersSortOrder | undefined,
): GetUsersFilter | undefined => {
  const { sortColumn: _, sortOrder: __, ...rest } = filter ?? {}
  if (!sortOrder?.sortColumn) {
    return Object.keys(rest).length > 0 ? rest : undefined
  }
  return {
    ...rest,
    sortColumn: sortOrder.sortColumn,
    sortOrder: sortOrder.sortOrder,
  }
}
